import React from 'react'
import videojs from 'video.js'
import type Player from 'video.js/dist/types/player'
import 'video.js/dist/video-js.css'

export type VideoSource =
  | string
  | {
    type: string
    src: string
  }
export interface VideoJSProps {
  options: {
    autoplay?: boolean | 'play' | 'muted' | 'any'
    sources: VideoSource | VideoSource[]
  }
  onReady?: Function
}
export const VideoJSView = (props: {} & VideoJSProps) => {
  const videoRef = React.useRef<HTMLDivElement>(null)
  const playerRef = React.useRef<null | Player>(null)
  const { options, onReady } = props

  let localOptions = { controls: true, ...options }

  React.useEffect(() => {
    console.log('VideoJsView useEff1')
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('vjs-big-play-centered')
      if (!videoRef.current) {
        console.error('No videoRef current')
      } else {
        videoRef.current.appendChild(videoElement)

        const player: Player = (playerRef.current = videojs(videoElement, localOptions, () => {
          videojs.log('player is ready')
          onReady && onReady(player)
        }))
      }

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current

      player.autoplay(options.autoplay)
      player.src(options.sources)
    }
  }, [options, videoRef])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    console.log('VideoJsView useEff2')
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <div data-vjs-player data-file="VideoJs">
      <div ref={videoRef} />
    </div>
  )
}

export default VideoJSView
